export function initAccordionExtended(wrapper = document) {
    const sections = wrapper.querySelectorAll('.accordionExtended');

    sections.forEach(section => {
        const items = section.querySelectorAll('.accordionExtended__gridItem');

        items.forEach(gridItem => {
            const trigger = gridItem.querySelector('.accordionExtended__item');
            const panel = gridItem.querySelector('.accordionExtended__panel');
            if (!trigger || !panel) return;

            trigger.addEventListener('click', () => {
                const isOpen = trigger.getAttribute('aria-expanded') === 'true';

                // close all items in this section
                items.forEach(otherItem => {
                    otherItem.querySelector('.accordionExtended__item').setAttribute('aria-expanded', 'false');
                    otherItem.querySelector('.accordionExtended__panel').classList.remove('is-open');
                });

                if (!isOpen) {
                    trigger.setAttribute('aria-expanded', 'true');
                    panel.classList.add('is-open');
                    const panelInner = panel.querySelector('.accordionExtended__panelInner');
                    if (panelInner) {
                        panel.addEventListener('transitionend', () => panelInner.focus(), { once: true });
                    }
                }
            });
        });
    });
}
